import {
  GET_ADMIN_LEAD_REFUNDS,
  GET_ADMIN_LEAD_REFUNDS_SUCCESS,
  GET_ADMIN_LEAD_REFUNDS_ERROR,
  UPDATE_ADMIN_LEAD_REFUND,
  UPDATE_ADMIN_LEAD_REFUND_SUCCESS,
  UPDATE_ADMIN_LEAD_REFUND_ERROR,
  DELETE_ADMIN_LEAD_REFUND,
  DELETE_ADMIN_LEAD_REFUND_SUCCESS,
  DELETE_ADMIN_LEAD_REFUND_ERROR,
} from "./actionTypes"

export const getAdminLeadRefunds = (query_params, paginated) => ({
  type: GET_ADMIN_LEAD_REFUNDS,
  payload: query_params,
  paginated: paginated
})

export const getAdminLeadRefundsSuccess = (lead_refund, meta) => {
  return {
    type: GET_ADMIN_LEAD_REFUNDS_SUCCESS,
    payload: lead_refund,
    meta,
  }
}

export const getAdminLeadRefundsError = (error) => {
  return {
    type: GET_ADMIN_LEAD_REFUNDS_ERROR,
    payload: error,
  }
}

export const updateAdminLeadRefund = (payload) => {
  return {
    type: UPDATE_ADMIN_LEAD_REFUND,
    payload: payload,
  }
}

export const updateAdminLeadRefundSuccess = (lead_refund) => {
  return {
    type: UPDATE_ADMIN_LEAD_REFUND_SUCCESS,
    payload: lead_refund,
  }
}

export const updateAdminLeadRefundError = (error) => {
  return {
    type: UPDATE_ADMIN_LEAD_REFUND_ERROR,
    payload: error,
  }
}

export const deleteAdminLeadRefund = (payload) => {
  return {
    type: DELETE_ADMIN_LEAD_REFUND,
    payload: payload,
  }
}

export const deleteAdminLeadRefundSuccess = (lead_refund) => {
  return {
    type: DELETE_ADMIN_LEAD_REFUND_SUCCESS,
    payload: lead_refund,
  }
}

export const deleteAdminLeadRefundError = (error) => {
  return {
    type: DELETE_ADMIN_LEAD_REFUND_ERROR,
    payload: error,
  }
}
